export class CommonConstant {
    /** 画面に表示する共通ID名称 */
    static readonly COMMON_ID_NAME: string = "ブリヂストンタイヤショップ共通ID" as string;

    /** 性別のリスト */
    static readonly GENDER_LIST: Array<any> = [
        {name: "選択：性別", value: ""},
        {name: "男性", value: "男性"},
        {name: "女性", value: "女性"},
        {name: "その他", value: "その他"},
        {name: "選択しない", value: "選択しない"},
    ];

    /** 車種頭文字 その他 */
    static readonly CAR_TYPE_INITIAL_OTHER: string = "その他" as string;

    /** 車種名称 その他 */
    static readonly CAR_TYPE_OTHER: string = "その他" as string;
}